import CommonImage from '../commons/Image'

export default class DocumentImage extends CommonImage {}
